import React from 'react';
interface CtaButtonProps {
  href: string;
  children: React.ReactNode;
  className?: string;
}
export function CtaButton({
  href,
  children,
  className = ''
}: CtaButtonProps) {
  return <a href={href} className={`inline-flex w-full items-center justify-center rounded-xl border-b-4 border-[#b39600] bg-accent px-5 py-3.5 text-center font-display text-sm font-extrabold uppercase tracking-wide text-canvas shadow-[0_0_0_3px_rgb(255_214_0/0.18)] transition-[background-color,transform] duration-150 ease-soft hover:bg-accent-strong active:translate-y-px active:scale-[0.99] sm:text-lg ${className}`} data-id="element-160" data-mp="1vvhde7s5cuuj">
      {children}
    </a>;
}